import { Injectable } from '@angular/core';
import { HttpRestService } from '@core/services/http-rest.service';
import { APIAdminClient } from '@core/typings/api/admin-client.typing';

@Injectable({ providedIn: 'root' })
export class ProgramFormsResources {
  constructor (
    private http: HttpRestService
  ) { }

  fetchFormsByProgramId (programId: number): Promise<APIAdminClient.GrantProgramFormFromApi[]> {
    return this.http.get('/api/manager/programs/' + programId + '/forms');
  }
}
